import { render, staticRenderFns } from "./GaEventsTable.vue?vue&type=template&id=51bd5fa0&scoped=true&"
import script from "./GaEventsTable.vue?vue&type=script&lang=ts&"
export * from "./GaEventsTable.vue?vue&type=script&lang=ts&"
import style0 from "./GaEventsTable.vue?vue&type=style&index=0&id=51bd5fa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bd5fa0",
  null
  
)

export default component.exports